import React, { useState } from "react";
import { withTranslation } from 'i18n';
import { useRouter } from "next/router";
import { AiOutlineArrowRight } from "react-icons/ai";
import { BiArrowBack } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { selectExamMode } from "redux/onlineExam/onlineExam.selectors";
import { stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";
import { Box } from "styled-components/box";

export const ExamMode = {
  simple: 0,
  advance: 1,
}


const index = ({ header, title, t, disableBack = false, showReport = false }) => {
  const [showModal, setShowModal] = useState(false)
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    examMode
  } = useSelector(
    createStructuredSelector({

      //examMode
      examMode: selectExamMode
    })
  );


  return (
    <Box style={{ zIndex: "100" }} className="d-flex shadow app-bg-white px-1 top-0 position-fixed bg-white w-100" height={'3em'}>

      {!disableBack && <Box width={'1em'} className="app-text-md mr-3 p-0 bg-transparent border-0  text-decoration-none align-self-center"
        onClick={() => router.back()}>
        {process.env.NEXT_PUBLIC_RTL ? <AiOutlineArrowRight /> : <BiArrowBack />}
      </Box>}

      <Box className=" mr-1 w-100 text-center align-self-center">
        <strong className="text-blue text-center">
          {/* {(title && title) || (router.query.slug && router.query.slug)} */}
          {t(title)}
        </strong>

      </Box>

   
      {/* {(showReport && examMode !== ExamMode.simple) && <p className="d-flex flex-grow-1 h-100 align-items-center justify-content-end text-danger"
        onClick={() => { if (router.query.showAnswer) {  dispatch(setExamType(ExamMode.simple)) } else {  setShowModal(false)
          dispatch(setExamType(ExamMode.simple))} }}>
        غیرفعالسازی انیمیشن
            </p>} */}


    </Box>
  )
};

export default withTranslation(stringFiles.common)(index);  
